module.exports = __webpack_public_path__ + "site/img/27.62fb33dd.jpg";